define(["underscore", "utils/match-criteria"], function(_, MatchCriteria) {
  function ItemClassConfig(name, matchCriteria, config, superClass) {
    this.localMatchCriteriaDefinition = new MatchCriteria(config.definition);
    // this.matchCriteraDefinition = new MatchCritera.And(this.localMatchCriteriaDefinition, superClass matchCriteraDefinition);

    this.name = name;
    this.definitionMatchCriteria = matchCriteria;
    this.config = config;
    this.superClass = superClass;
  }

  _.extend(ItemClassConfig.prototype, {
    matchesResult: function(resultProperty) {
      return this.localMatchCriteriaDefinition.matches(resultProperty);

      // @todo and von matchCrtiera + superClasses
      return this.matchCriteraDefinition.matches(resultProperty);
    },

    getPropertiesByEntityFormat: function(destClass /*: ItemClassConfig | undefined*/) {
      if (!this.config.properties) {
        return {};
      }

      var props = this.config.properties;

      return _.reduce(
        _.keys(props),
        function(result, propKey) {
          var prop = props[propKey];
          prop = _.extend({ name: propKey }, prop);
          if (prop.type == "string" && prop.entityFormat) {
            var entityFormat = prop.entityFormat;
            var entityFormatName;
            if (_.isObject(entityFormat)) {
              entityFormatName = entityFormat.name;
              if (destClass && entityFormat.itemClasses) {
                var found = _.find(entityFormat.itemClasses, function(itemClassName) {
                  // TODO also check if a super class would match
                  return itemClassName == destClass.name;
                });
                if (!found) {
                  // ignore this match
                  return result;
                }
              }
            } else {
              entityFormatName = entityFormat;
            }
            if (!result[entityFormatName]) {
              result[entityFormatName] = [prop];
            } else {
              result[entityFormatName].push(prop);
            }
          }
          return result;
        },
        {}
      );
    },

    getPropertyDefinitionsForEntityFormat: function(entityFormat, options) {
      var propsByEF = this.getPropertiesByEntityFormat();
      if (!propsByEF[entityFormat.name]) {
        return [];
      }

      var whereConditions = {};
      var unique = options && options.unique;
      if (unique !== undefined) {
        whereConditions.unique = unique;
      }

      function matchWhere(object, whereORConditions) {
        var found = false;
        var whereKeys = _.keys(whereORConditions);
        for (var i = 0; i < whereKeys.length; i++) {
          var whereKey = whereKeys[i];
          var whereValue = whereORConditions[whereKey];
          if (object[whereKey] == whereValue) {
            found = true;
            break;
          }
        }

        return found;
      }

      var res = _.filter(propsByEF[entityFormat.name], function(propertyDef) {
        return matchWhere(propertyDef, whereConditions);
      });

      if (res.length) {
        return res[0];
      }

      return null;
    }
  });

  return ItemClassConfig;
});
